import * as marietta3d from '..';
import * as marietta from '../../marietta';

export default class AutoMain {
        public autoData: marietta3d.AutoGen.AutoBase;

        private scale: marietta3d.AutoGen.Scale;

        public Model: marietta3d.AutoGen.ConstructionModel;

        /*------------------------------------------------------
        *constructor
        */
        constructor(data: marietta3d.AutoGen.AutoBase) {
          this.autoData = data;
          this.scale = this.autoData.scaleObj;
          this.Model = this.autoData.Model;
        }

        /*------------------------------------------------------
        * 起動URL
        */
        public setWebcadUrl(base: string, webcad: string, api: string, assets:string, assets3d:string) {
          this.autoData.setWebcadUrl(base, webcad, api, assets, assets3d);
        }

        /*------------------------------------------------------
        * WebCAD データの読み込み
        */
        public fileImport =(doc: any) => {
          try {
            const file = doc.getElementById('filePicker').files[0];
            // var fileName = file.name;
            // var fileSize = file.size + "bytes";
            // var fileType = file.type;
            // document.getElementById( "fileAttribute" ).textContent = fileName;

            const reader = new FileReader();
            reader.addEventListener('load', this.importXML, false);
            reader.readAsText(file, 'utf-8');
          } catch (e) {
            console.error(e);
          }
        }

        /*------------------------------------------------------
        * [Event Handler]WebCAD データの読み込み
        */
        public importXML(e: any) {
          const xml = e.target.result;
          this.perseXML(xml);
        }

        /*------------------------------------------------------
        * WebCADデータの読み込み
        */
        public perseXML(xml: string) {
          this.autoData.perseXML(xml);
          // this.autoData.draw();
          /*
            var p1 = new Point( 1760, 1300, 0 );
            var p2 = new Point( 1800, 1360, 0 );
            this.semiAutoFittingGen( 1, p1, p2 );
            */
        }

        /**
         * WebCADデータの読み込み
         * @param json
         */
        public parseJSON(json: any) {
          this.autoData.parseJSON(json);
        }

           /* initMaterials
     * セットアップ.
     */
    public initMaterials() {
        this.loadMaterialData(marietta.webcad.WebCADGlobal.covertToNoCacheURL(marietta.view3d.webcad.View3dGlobal.shared.matDefPath));
        this.loadDefaultStyleData(marietta.webcad.WebCADGlobal.covertToNoCacheURL(marietta.view3d.webcad.View3dGlobal.shared.styDefPath));
        this.loadColorData(marietta.webcad.WebCADGlobal.covertToNoCacheURL(marietta.view3d.webcad.View3dGlobal.shared.clrDefPath));
    }

    /*------------------------------------------------------
    * material 用 XML の読み込み
    */
    private loadMaterialData(url: string) {
        const httpObj = new XMLHttpRequest();
        httpObj.open("GET", url, true);
        httpObj.onreadystatechange = () => {
            if (httpObj.readyState == 4) {
                const xml: any = httpObj.responseXML;
                if (xml != undefined)
                    this.perseMaterialXML(xml);
            }
        }
        httpObj.send(null);
    }

    /*------------------------------------------------------
    * material 用　デフォルト XML の読み込み
    */
    private loadDefaultStyleData(url: string) {
        const httpObj = new XMLHttpRequest();
        httpObj.open("GET", url, true);
        httpObj.onreadystatechange = () => {
            if (httpObj.readyState == 4) {
                const xmlData: any = httpObj.responseXML;
                const jsonData = marietta.webcad.util.WebcadJSONParser.modelParamXmlToJson(xmlData);
                if (jsonData != undefined)
                    this.perseDefaultMaterialJson(jsonData);
            }
        }
        httpObj.send(null);
    }

    /*------------------------------------------------------
    * color/parts 用 XML の読み込み
    */
    private loadColorData(url: string) {
        const httpObj = new XMLHttpRequest();
        httpObj.open("GET", url, true);
        httpObj.onreadystatechange = () => {
            if (httpObj.readyState == 4) {
                const xml: any = httpObj.responseXML;
                if (xml != undefined)
                    this.perseColorXML(xml);
            }
        }
        httpObj.send();
    }

        /**
         *  部屋の色指定XMLの読み込み
         * @param xml
         */
        public perseColorXML(xml: Document) {
          const root = xml.getElementsByTagName('Data');
          const color = root[0].getElementsByTagName('color');
          if (color.length > 0) {
            const itemList = color[0].getElementsByTagName('item');

            for (let i = 0; i < itemList.length; i += 1) {
              const ss = new marietta3d.AutoGen.object.FloorColor();
              ss.readXML(itemList[i]);

              this.autoData.sysColor.Add(ss);
            }
          }
          const root3 = root[0].getElementsByTagName('fitting');
          if (root3.length > 0) {
            const fitList = root3[0].getElementsByTagName('item');

            for (let i = 0; i < fitList.length; i += 1) {
              const highList = fitList[i].getElementsByTagName('type');
              if (highList.length > 0) {
                const attr = highList[0].attributes;
                const nodeHName = attr.getNamedItem('height');
                let hname = '';
                let done = false;
                if (nodeHName != null) {
                  hname = nodeHName.nodeValue;
                  for (let j = 0; j < this.autoData.sysFittingDef.length; j += 1) {
                    if (this.autoData.sysFittingDef[j].IsHit(hname) === true) {
                      this.autoData.sysFittingDef[j].readXML(highList[i]);
                      done = true;
                      break;
                    }
                  }
                  if (done === false) {
                    const hDef = new marietta3d.AutoGen.object.AutoObjFitHigh();
                    hDef.highName = hname;
                    this.autoData.sysFittingHigh.push(hDef);
                    hDef.readXML(highList[0]);
                  }
                }
              } else {
                const fit = new marietta3d.AutoGen.object.AutoObjFitDef();
                fit.readXML(fitList[i]);

                this.autoData.sysFittingDef.push(fit);
              }
            }
          }
          const root2 = root[0].getElementsByTagName('parts');
          if (root2.length > 0) {
            const partsList = root2[0].getElementsByTagName('item');

            for (let i = 0; i < partsList.length; i += 1) {
              const sp = new marietta3d.AutoGen.object.AutoObjParts();
              sp.readXML(partsList[i]);

              this.autoData.sysAutoParts.push(sp);
            }
          }
        }

        /**
         *  material XML の読み込み
         * @param xml
         */
        public perseMaterialXML(xml: Document) {
          const root = xml.getElementsByTagName('material');
          const itemList = root[0].getElementsByTagName('item');

          this.autoData.Model.readMaterialList(itemList);
        }

        /**
         * 建物に対する初期 material の読み込み
         * @param xml
         */
        public perseDefaultMaterialJson(jsonData: any) {
          if (jsonData) {
            this.autoData.Model.readJSON(jsonData);
          }
        }

        /**
        * 建物に対する初期 自動パラメータ の読み込み
        * @param xml
        */
        public perseModelAutoXML(jsonData) {
          if (jsonData != null) {
            const root = jsonData.a_roof;
            if (root.length > 0) {
              this.autoData.Model.readAutoXML(root);
            }
          }
        }

        /**
         * 建物に対する初期 自動パラメータ の読み込み
         * @param xml
         */
        public perseModelHeightXML(jsonData:any) {
          if (jsonData != null) {
            this.autoData.Model.readModelHeightXML(jsonData);
          }
        }

        /**
         * Draw to canvas
         * @param flr
         * @param ctx
         */
        public debugDraw(flr: number, ctx: CanvasRenderingContext2D) {
          this.autoData.debugDraw(flr, ctx);
        }

        /**
         * 情報表示
         * @param wp
         */
        public ObjectInfo(wp: marietta.core.Point) {
          this.autoData.ObjectInfo(wp);
        }

        /*------------------------------------------------------
        * IsHit
        */
        public IsHit(wp: marietta.core.Point): any {
          return this.autoData.IsHit(wp);
        }

        /*------------------------------------------------------
        * drawDimension
        */
        public drawDimension(dim: marietta3d.AutoGen.object.AutoObjDimension, ctx: CanvasRenderingContext2D) {
          dim.draw(this.scale, ctx);
        }

        // /**
        // * [API]立体生成リクエスト (3D表示用)
        // * @param start3D
        // * @param cb_timeout
        // */
        // public request3D(start3D: Function, cbTimeout:Function) {
        //   this.culcScale(100, 100); // 3D座標への変換のため。（100,100はダミー）
        //   const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
        //   // serverApi.ReqPlanArea( null ); // 面積計算
        //   serverApi.Req3D(start3D, cbTimeout, this.scale);
        // }

        /**
        * [API]立体イメージリクエスト
        * @param start3D
        * @param cbTimeout
        */
        public request3DImages(start3D: Function, cbTimeout:Function) {
          this.culcScale(100, 100); // 3D座標への変換のため。（100,100はダミー）
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          // serverApi.ReqPlanArea( null ); // 面積計算
          serverApi.Req3DImages(start3D, cbTimeout, this.scale);
        }

        /**
        * [API]自動建具リクエスト
        * @param cb
        */
        public requestFittingGen(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqFittingGen(cb);
        }

        /**
         * [API]自動住設リクエスト
         * @param cb
         */
        public requestEquipmentGen(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqEquipmentGen(cb);
        }

        /**
        * [API]建具選択リストリクエスト
        */
        // public requestFittingList( cbs: Function, cberr:Function )
        // {
        //     var serverApi = new marietta3d.manager.ApiRequest( this.autoData );
        //     serverApi.ReqFittingList( cbs, cberr );
        // }

        /*------------------------------------------------------


        /*------------------------------------------------------
        * [API]プランデータ Export リクエスト
        */
        public requestExport(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqExportFile(cb);
        }

        /*------------------------------------------------------
        * [ローカル]高手入力屋根用の初期値情報
        */
        public GetRoofInitParam(): {} {
          const vA = Number(this.autoData.Model.GetSlabLevel2());
          const vB = Number(this.autoData.Model.GetSlabLevel3());
          const vC = Number(this.autoData.Model.GetSlabLevel4());
          const vSlope = Number(this.autoData.Model.GetAutoRoofSlope());
          const vNokiDE = Number(this.autoData.Model.GetAutoRoofNokide());
          const vTumaDE = Number(this.autoData.Model.GetAutoRoofTumade());
          return {
            NokiH_1: vA.toString(),
            NokiH_2: vB.toString(),
            NokiH_3: vC.toString(),
            Slope: vSlope.toString(),
            Nokide: vNokiDE.toString(),
            Tumade: vTumaDE.toString(),
          };
        }

        /*------------------------------------------------------
        *[ローカル]高さ指定用ダイアログへ値を渡す
        */
        public GetDesignHigh(): {} {
          const vA2 = Number(this.autoData.Model.GetFloor1());
          const vB2 = Number(this.autoData.Model.GetFloor2());
          const vC2 = Number(this.autoData.Model.GetFloor3());
          const vA1 = Number(this.autoData.Model.GetCeiling1());
          const vB1 = Number(this.autoData.Model.GetCeiling2());
          const vC1 = Number(this.autoData.Model.GetCeiling3());
          const vD = vA2 + Number(this.autoData.Model.GetSlabLevel1());
          const vA = Number(this.autoData.Model.GetSlabLevel2());
          const vB = Number(this.autoData.Model.GetSlabLevel3()) - Number(this.autoData.Model.GetSlabLevel2());
          const vC = Number(this.autoData.Model.GetSlabLevel4()) - Number(this.autoData.Model.GetSlabLevel3());
          return {
            A: vA.toString(),
            A1: vA1.toString(),
            A2: vA2.toString(),
            B: vB.toString(),
            B1: vB1.toString(),
            B2: vB2.toString(),
            C: vC.toString(),
            C1: vC1.toString(),
            C2: vC2.toString(),
            D: vD.toString(),
            E1: this.autoData.Model.GetBasePackin(),
            E2: this.autoData.Model.GetBaseLevel(),
            F: this.autoData.Model.GetEntranceLevel(),
          };
        }

        /*------------------------------------------------------
        * [ローカル]高さ指定用ダイアログから値をもらう
        */
        public SetDesignHigh(A: string, A1: string, A2: string, B: string, B1: string, B2: string, C: string, C1: string, C2: string, D: string, E1: string, E2: string, F: string) {
          const a = Number(A);
          const a2 = Number(A2);
          const b = Number(B);
          const c = Number(C);
          const d = Number(D);
          const sl1 = d - a2;
          const sl2 = a;
          const sl3 = a + b;
          const sl4 = a + b + c;
          this.autoData.Model.SetSlabLevel1(sl1);
          this.autoData.Model.SetSlabLevel2(sl2);
          this.autoData.Model.SetSlabLevel3(sl3);
          this.autoData.Model.SetSlabLevel4(sl4);
          this.autoData.Model.SetCeiling1(Number(A1));
          this.autoData.Model.SetFloor1(Number(A2));
          this.autoData.Model.SetCeiling2(Number(B1));
          this.autoData.Model.SetFloor2(Number(B2));
          this.autoData.Model.SetCeiling3(Number(C1));
          this.autoData.Model.SetFloor3(Number(C2));
          this.autoData.Model.SetBasePackin(Number(E1));
          this.autoData.Model.SetBaseLevel(Number(E2));
          this.autoData.Model.SetEntranceLevel(Number(F));
        }

        /*------------------------------------------------------
        *[ローカル]1点を指定して、建具アイテム・コードを生成する
        */
        public semiAutoFittingGen(flr: number, p1: marietta.core.Point, p2: marietta.core.Point): { item: string, x: number, y: number, angle: number, width: number } {
          this.autoData.MakeWall();
          const wall = this.autoData.AGFittingWall(flr, p1, p2);
          const fp: marietta.core.Point = this.autoData.AGFittingPoint(wall, p1, p2);
          const wd: number = this.autoData.AGFittingWidth(wall, p1, p2);
          const id: string = this.autoData.AGFittingItem(wall, wd);
          const ln = wall.CopyLine(this.autoData.PlanPnt);
          const a = -(new marietta.core.Point(ln.e.x, ln.e.y, ln.e.flag).angle(new marietta.core.Point(ln.s.x, ln.s.y, ln.s.flag)));
          if (id === '') {
            return {
              item: null,
              x: fp.x,
              y: fp.y,
              angle: a,
              width: wd,
            };
          }
          return {
            item: id,
            x: fp.x,
            y: fp.y,
            angle: a,
            width: wd,
          };
        }

        /*------------------------------------------------------
        *[ローカル]部屋の結合
        */
        public MargeRoom(flr: number, idx1: string, idx2: string): marietta3d.AutoGen.utils.RoomPointArray {
          const localApi = new marietta3d.AutoGen.AutoArea(this.autoData);
          return localApi.MargeRoom(flr, idx1, idx2); // 部屋の結合
        }

        /*------------------------------------------------------
        *[API]プランのSVGをPNGに変換
        */
        public requestSvgThumbnail(flr: number, sizex: number, sizey: number, format: number, minmap:number, cb:Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqSvgThumbnail(cb, flr, sizex, sizey, format, minmap);
        }

        /*------------------------------------------------------
        *[API]自動屋根生成リクエスト
        */
        public requestAutoRoof(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqAutoRoof(cb); // cb is call back with ( Array<AutoObjRoof> )
        }

        /*------------------------------------------------------
        *[API]指定階の寸法生成
        */
        public requestAutoDimension(flr: number, cb:Function) {
          // var localApi = new AutoGen.autoDimension(this.autoData);
          // localApi.AGDimension(flr);
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqDimension(cb, flr, this.scale);
          // callback( this.autoGen.DimensionList[flr - 1] );
        }

        /*------------------------------------------------------
        *3D空間用の寸法データを返す
        */
        public requestDimension3D(flr: number, cb: Function) {
          // var localApi = new AutoGen.autoDimension(this.autoData);
          // localApi.AGDimension(flr);
          this.culcScale(100, 100); // 3D座標への変換のため。（100,100はダミー）
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqDimension3D(cb, flr, this.scale);
          // callback( this.autoGen.DimensionList[flr - 1] );
        }

        /*------------------------------------------------------
        *[API]指定階の廊下生成
        */
        public requestAutoHallway(flr: number, cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqHallwayGen(cb);
        }

        /*------------------------------------------------------
        *[API]3Dで廊下生成が必要かのチェック
        */
        public checkAutoHallway(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqCheckHallway(cb);
        }

        /*------------------------------------------------------
        *[API]外周が複数に分かれているかのチェック
        */
        public RequestOutDivideCheck(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqOutDivideCheck(cb);
        }

        /*------------------------------------------------------
        *[API] 壁リストを取得
        */
        public RequestMakeRoomWall(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqMakeRoomWall(cb);
        }

        /*------------------------------------------------------
        *[API]建築面積、床面積、間口、奥行き
        * */
        public requestPlanArea(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqPlanArea(cb);
          // serverApi.ReqEstimate( cb );
          // callback( PlanAreaInfo )
          /*
            for ( var i = 0; i < this.autoData.maxFloor; i++ ) {
                this.requestAutoHallway( i+1 );
            }
            var localApi = new AutoGen.AutoArea(this.autoData);

            localApi.AGPlanInfo(); // 面積計算

            var pinfo = new marietta3d.AutoGen.PlanAreaInfo();
            for ( var i = 0; i < this.autoData.maxFloor; i++ ) {
                pinfo.yukaMenseki[i] = this.autoData.yukaMenseki[i];
                pinfo.koujiMenseki[i] = this.autoData.koujiMenseki[i];
            }
            pinfo.roomCount = this.autoData.roomCount;
            pinfo.genkanhoko = this.autoData.genkanhoko;
            pinfo.maguchi = this.autoData.maguchi;
            pinfo.okuyuki = this.autoData.okuyuki;

            return pinfo;
            */
        }

        /*------------------------------------------------------
        *[API]拾い出し
        *
        * */
        public requestEstimate(cb: Function) {
          const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
          serverApi.ReqEstimate(cb);
        }

        /*------------------------------------------------------
        *建築情報＋マテリアル情報
        */
        public GetConstructionModel(): marietta3d.AutoGen.ConstructionModel {
          return this.autoData.Model;
        }

        /*------------------------------------------------------
        * WebCAD Value --> World Value
        */
        public ConvertCadToWorld(v: number): number {
          return this.scale.ConvertCadToWorld(v);
        }

        /*------------------------------------------------------
        * World Value --> WebCAD Value
        */
        public ConvertWorldToCad(v: number): number {
          return this.scale.ConvertWorldToCad(v);
        }

        /*------------------------------------------------------
        * Screen Coodinate --> WebCAD Coodinate
        */
        public ConvertToWebCAD(p: marietta.core.Point): marietta.core.Point {
          return this.scale.ConvertToWebCAD(p);
        }

        /*------------------------------------------------------
        * WebCAD Coodinate --> Screen Coodinate
        */
        public ConvertToScreen(p: marietta.core.Point): marietta.core.Point {
          return this.scale.ConvertToCanvas(p);
        }

        /*------------------------------------------------------
        * WebCAD Coodinate --> 3D Model(Collada) Coodinate
        */
        public ConvertTo3DModelFromWebCAD(p: marietta.core.Point): marietta.core.Point {
          return this.scale.ConvertTo3DModelFromWebCAD(p);
        }

        /*------------------------------------------------------
        * 3D Model(Collada)Coodinate  --> WebCAD Coodinate
        */
        public ConvertToWebCADFrom3DModel(p: marietta.core.Point): marietta.core.Point {
          return this.scale.ConvertToWebCADFrom3DModel(p);
        }

        /*------------------------------------------------------
        * Initialize View parameta
        *
        */
        public culcScale(ctxW: number, ctxH: number) {
          this.autoData.culcScale(ctxW, ctxH);
        }

        /*------------------------------------------------------
        * Erace Screen
        *
        */
        public ClearScreen(ctx: CanvasRenderingContext2D) {
          ctx.clearRect(0, 0, this.scale.ctxWidth, this.scale.ctxHeight);
        }

        /*------------------------------------------------------
        * SScale
        * Offset at SCREEN Coordinate
        */
        public ScreenOffset(down: marietta.core.Point, move: marietta.core.Point) {
          this.scale.ScreenOffset(down, move);
        }

        /*------------------------------------------------------
        * SScale
        * View scale    sc > 1.0 scale UP
        *               sc < 1.0 scale DOWN
        */
        public SetViewScale(pin: marietta.core.Point, sc: number) {
          this.scale.SetViewScale(pin, sc);
        }

        /*------------------------------------------------------
        * SScale
        * View size
        */
        public SetViewSize(ctxW: number, ctxH: number) {
          this.scale.SetViewSize(ctxW, ctxH);
        }

        /*------------------------------------------------------
        *[API]拾い出し
        *
        * */
          public requestStartsQuotationList(cb: Function) {
            const serverApi = new marietta3d.manager.ApiRequest(this.autoData);
            serverApi.ReqStartsQuotationList(cb);
          }

}
